import React, { FC } from "react";
import { Button, CircularProgress } from "@material-ui/core";
import { makeStyles, Theme } from "@material-ui/core/styles";

import { TEXTS } from "../../constants";
import StyledTooltip from "../Common/StyledTooltip";

const useStyles = makeStyles((theme: Theme) => ({
  pdfBtn: {
    width: "auto",
    paddingLeft: "0.7rem",
    paddingRight: "0.7rem",
    height: "30px",
    backgroundColor: "#ff8f3d",
    color: theme.palette.primary.contrastText,
    textTransform: "none",
  },
  loading: {
    marginRight: "4px",
  },
}));

interface DownloadPdfProps {
  handlePdfDownload: any;
  isDisabled?: boolean;
  isLoading: boolean;
}

const PDF: FC<DownloadPdfProps> = ({ handlePdfDownload, isDisabled, isLoading }) => {
  const classes = useStyles();

  return (
    <StyledTooltip title={TEXTS.PDF_REPORT_TOOLTIP}>
      <Button
        variant="contained"
        size="small"
        className={classes.pdfBtn}
        onClick={handlePdfDownload}
        disabled={isDisabled}
      >
        {isLoading ? <CircularProgress size={20} color="primary" className={classes.loading} /> : null}
        Create Custom Report
      </Button>
    </StyledTooltip>
  );
};

export default PDF;
